import axios from "axios";
const baseURL="https://ecombackend-n9in.onrender.com/api/"
const TOKEN=JSON.parse((JSON.parse(localStorage.getItem("persist:root"))?.user)||`{
    "name": "vivek",
    "age": 29,
    "secretIdentity": "Dan Jukes",
    "powers": ["Radiation resistance", "Turning tiny", "Radiation blast"]
  }`)?.currentUser?.accessToken;

export const publicRequest = axios.create({
    baseURL:baseURL
});

export const userRequest=axios.create({
    baseURL:baseURL,
    headers:{token:`Bearer ${TOKEN}`}
})